import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { loginGuard } from './guards/login.guard';
import { LoginComponent } from './public/login/login.component';
import { ProfileComponent } from './private/profile/profile.component';
import { RegistrationComponent } from './public/registration/registration.component';
import { ForgotPasswordComponent } from './public/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './public/reset-password/reset-password.component';
import { PageNotFoundComponent } from './public/page-not-found/page-not-found.component';

export const ROUTES_DOMAIN_B: Routes = [
 { path: '', redirectTo: 'login', pathMatch: 'full' },
   { path: 'login', component: LoginComponent, canActivate: [loginGuard] },
   {
    path: 'registration/:email',
    component: RegistrationComponent
  },
   { path: 'forgot-password', component: ForgotPasswordComponent },
   { path: 'reset-password/:email', component: ResetPasswordComponent },
   { path: 'profile', component: ProfileComponent, canActivate: [authGuard], data: { title: 'Profile' } },
   {
    path: '**',
    component: PageNotFoundComponent,
    data: { title: '404 - Page Not Found' }
  }
];
